"use client";

import { FileText, Cloud } from "lucide-react";
import DriveIcon from "./DriveIcon";

type Props = {
  size?: number;
  classNameContent?: string;
  className?: string;
};

export const DriveFileIcon = ({ size = 28, classNameContent, className }: Props) => {
  const badgeSize = size * 0.45;

  return (
    <div className={`relative inline-flex ${classNameContent || ""}`} style={{ width: size, height: size }}>
      <FileText strokeWidth={1}  size={size} className={`  ${className || ""}`}  />
      <div className="absolute -bottom-1 -right-1 rounded-full bg-white p-[2px]">
        <DriveIcon size={badgeSize}/>
      </div>
    </div>
 
  );
};
